// extracted by mini-css-extract-plugin
module.exports = {"LessonContainer":"LessonViewerTabs_LessonContainer__1lU_O","LessonOutlet":"LessonViewerTabs_LessonOutlet__4f-rx"};